import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Check from '@material-ui/icons/CheckCircle';

import { Round } from '../../../../functions/Maths';

function incrementoPorcentual(nuevo, anterior) {
    const n = nuevo ? parseInt(nuevo, 10) : 0;
    const a = anterior ? parseInt(anterior, 10) : 0;
    return Math.round(((n - a) / a) * 100 * 100) / 100;
}

class Total extends React.Component {
    state = {
        id: undefined,
        pending: false,
        temp: '',
    };

    static getDerivedStateFromProps(props, state) {
        if (
            props.forecast &&
            (props.forecast !== state.forecast ||
                props.id !== state.id ||
                (props.info &&
                    (props.info.ventadia !== state.ventadia ||
                        props.info.disabled !== state.disabled)))
        ) {
            const { ventadia, ventadiabase, disabled, importes, desvioactual } = props.info;

            state.forecast = props.forecast;
            state.id = props.id;
            state.ventadia = ventadia ? ventadia : undefined;
            state.temp = ventadia ? Round(ventadia) : '';
            state.ventadiabase = ventadiabase ? ventadiabase : ventadia;
            state.disabled = disabled ? disabled : false;
            state.importes = importes ? importes : [];
            state.desvioactual = desvioactual ? desvioactual : '';
            return state;
        }
        return null;
    }

    handleChange = (event) => {
        this.setState({ temp: event.target.value, pending: true });
    };

    handleClick = (event) => {
        const { importes, ventadia, temp } = this.state;
        const ranges = importes.reduce((available, i) => {
            available = available + (i.bloqueado ? 0 : i.importe);
            return available;
        }, 0);
        const incremento = temp - ventadia;
        const arr = importes.map((i) => {
            if (!i.bloqueado) {
                const percentage = (i.importe * 100) / ranges;
                i.importe += (incremento * percentage) / 100;
                i.importe = Math.round(i.importe * 100) / 100;
            }
            return i;
        });
        this.props.onChange('importes', arr);
        this.props.onChange('ventadia', temp);
        this.setState({ ventadia: event.target.value, importe: temp, pending: false });
    };

    render() {
        const { intl } = this.props;
        const { temp, ventadiabase, disabled, pending, desvioactual } = this.state;
        const percentage = incrementoPorcentual(temp, ventadiabase);
        return (
            <Card className={'production_total_card'}>
                <CardContent>
                    <Grid container className={'flex_grow_1 margin_top_8'}>
                        <Grid item xs={3} className="flex_full_column center">
                            <div className="flex_auto_row barlow_medium c_dark_grey_blue text_align_left">
                                {intl.formatMessage({ id: 'production_total_card_initial' })}
                                {': '}
                            </div>
                            <div
                                className={
                                    'flex_auto_row barlow_medium nowrap margin_left_12 margin_top_8 c_cornflower_blue'
                                }
                            >
                                {Round(ventadiabase) + ' €'}
                            </div>
                        </Grid>
                        <Grid item xs={3} className="padding_left_12 flex_full_column center">
                            <div className="flex_auto_row barlow_medium c_dark_grey_blue text_align_end">
                                {intl.formatMessage({ id: 'modification_forecast_new' })}
                                {': '}
                            </div>
                            <div
                                className={
                                    'flex_auto_row barlow_medium nowrap margin_left_12 margin_top_8 c_cornflower_blue'
                                }
                            >
                                {!disabled ? (
                                    <TextField
                                        fullWidth
                                        id={'temp'}
                                        name={'temp'}
                                        required
                                        className={'flex_full_row'}
                                        classes={{ root: 'production_total_card_input' }}
                                        value={temp}
                                        onChange={this.handleChange}
                                        margin="normal"
                                        InputProps={{
                                            pattern: '[0-9]*',
                                            classes: {
                                                input:
                                                    'c_dark_grey_blue barlow_medium text_align_right',
                                            },
                                            endAdornment: (
                                                <InputAdornment
                                                    position="end"
                                                    classes={{
                                                        root: 'production_total_card_adornment',
                                                    }}
                                                >
                                                    €
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                ) : (
                                    Round(temp) + ' €'
                                )}
                            </div>
                        </Grid>
                        <Grid item xs={2} className="flex_full_column center padding_left_12 ">
                            <div className="flex_auto_row barlow_medium c_dark_grey_blue elements_from_right">
                                {intl.formatMessage({
                                    id: 'production_total_card_deflection_actual',
                                })}
                                {': '}
                            </div>
                            <div
                                className={
                                    'flex_auto_row barlow_medium  elements_from_right nowrap margin_left_12 c_lipstick margin_top_8'
                                }
                            >
                                {Round(desvioactual) + ' %'}
                            </div>
                        </Grid>
                        <Grid item xs={3} className="flex_full_column center padding_left_12 ">
                            <div className="flex_auto_row barlow_medium c_dark_grey_blue elements_from_right">
                                {intl.formatMessage({ id: 'production_total_card_deflection' })}
                                {': '}
                            </div>
                            <div
                                className={
                                    'flex_auto_row barlow_medium  elements_from_right nowrap margin_left_12 margin_top_8 ' +
                                    (percentage >= 0 ? 'c_pea' : 'c_lipstick')
                                }
                            >
                                {Round(percentage) + ' %'}
                            </div>
                        </Grid>
                        <Grid item xs={1} className="MACHINE_flex center padding_left_12 ">
                            <Check
                                fontSize="large"
                                className={
                                    'hand padding_left_12 barlow_regular ' +
                                    (pending ? 'c_pea' : 'c_cool_grey_two')
                                }
                                onClick={this.handleClick}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        );
    }
}

Total.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Total);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/forecast/Total.js